import { render, staticRenderFns } from "./BrandProfileDetails.vue?vue&type=template&id=6ee8d41e&scoped=true"
import script from "./BrandProfileDetails.vue?vue&type=script&lang=js"
export * from "./BrandProfileDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee8d41e",
  null
  
)

export default component.exports